/* tslint:disable */
/* eslint-disable */
/**
 * Solid Slate
 * Booking, made easy
 *
 * The version of the OpenAPI document: 0.1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { MessageTypeEnum } from './MessageTypeEnum';
import {
    MessageTypeEnumFromJSON,
    MessageTypeEnumFromJSONTyped,
    MessageTypeEnumToJSON,
    MessageTypeEnumToJSONTyped,
} from './MessageTypeEnum';

/**
 *
 * @export
 * @interface ChatMessagePosted
 */
export interface ChatMessagePosted {
    /**
     *
     * @type {number}
     * @memberof ChatMessagePosted
     */
    readonly id: number;
    /**
     *
     * @type {number}
     * @memberof ChatMessagePosted
     */
    chat: number;
    /**
     *
     * @type {MessageTypeEnum}
     * @memberof ChatMessagePosted
     */
    messageType: MessageTypeEnum;
    /**
     *
     * @type {string}
     * @memberof ChatMessagePosted
     */
    content: string;
    /**
     *
     * @type {Date}
     * @memberof ChatMessagePosted
     */
    readonly createdAt: Date;
    /**
     *
     * @type {string}
     * @memberof ChatMessagePosted
     */
    readonly responseTaskId: string;
    /**
     *
     * @type {string}
     * @memberof ChatMessagePosted
     */
    readonly responseState: string;
    /**
     *
     * @type {number}
     * @memberof ChatMessagePosted
     */
    readonly responseTo: number | null;
    /**
     *
     * @type {string}
     * @memberof ChatMessagePosted
     */
    readonly taskId: string;
}



/**
 * Check if a given object implements the ChatMessagePosted interface.
 */
export function instanceOfChatMessagePosted(value: object): value is ChatMessagePosted {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('chat' in value) || value['chat'] === undefined) return false;
    if (!('messageType' in value) || value['messageType'] === undefined) return false;
    if (!('content' in value) || value['content'] === undefined) return false;
    if (!('createdAt' in value) || value['createdAt'] === undefined) return false;
    if (!('responseTaskId' in value) || value['responseTaskId'] === undefined) return false;
    if (!('responseState' in value) || value['responseState'] === undefined) return false;
    if (!('responseTo' in value) || value['responseTo'] === undefined) return false;
    if (!('taskId' in value) || value['taskId'] === undefined) return false;
    return true;
}

export function ChatMessagePostedFromJSON(json: any): ChatMessagePosted {
    return ChatMessagePostedFromJSONTyped(json, false);
}

export function ChatMessagePostedFromJSONTyped(json: any, ignoreDiscriminator: boolean): ChatMessagePosted {
    if (json == null) {
        return json;
    }
    return {

        'id': json['id'],
        'chat': json['chat'],
        'messageType': MessageTypeEnumFromJSON(json['message_type']),
        'content': json['content'],
        'createdAt': (new Date(json['created_at'])),
        'responseTaskId': json['response_task_id'],
        'responseState': json['response_state'],
        'responseTo': json['response_to'],
        'taskId': json['task_id'],
    };
}

  export function ChatMessagePostedToJSON(json: any): ChatMessagePosted {
      return ChatMessagePostedToJSONTyped(json, false);
  }

  export function ChatMessagePostedToJSONTyped(value?: Omit<ChatMessagePosted, 'id'|'created_at'|'response_task_id'|'response_state'|'response_to'|'task_id'> | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {

        'chat': value['chat'],
        'message_type': MessageTypeEnumToJSON(value['messageType']),
        'content': value['content'],
    };
}
